function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { string, oneOfType, node } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import SovosTypography from '../sovos-typography';
import SovosToolbarGroup from '../sovos-toolbar-group';
import SovosFixedWidthText from '../sovos-fixed-width-text';
const StyledToolbarGroup = styled(SovosToolbarGroup)({
  flex: '1 1 auto',
  minWidth: 0
});
const StyledTypography = styled(SovosTypography)(_ref => {
  let {
    theme: {
      palette,
      spacing
    }
  } = _ref;
  return {
    color: palette.text.primary,
    lineHeight: 'auto',
    paddingInlineEnd: spacing(2),
    position: 'relative'
  };
});

/**
 * **Note**: must be a child of `SovosToolbar`
 */
const SovosToolbarTitle = _ref2 => {
  let {
    children,
    className,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledToolbarGroup, _extends({
    className: clsx('sovosToolbarTitle', className)
  }, rest), /*#__PURE__*/React.createElement(StyledTypography, {
    component: "span",
    variant: "subtitle1",
    noWrap: true
  }, typeof children === 'string' ? /*#__PURE__*/React.createElement(SovosFixedWidthText, {
    text: children
  }) : children));
};
SovosToolbarTitle.propTypes = {
  /**
   * The content of the title. If a string, will show a tooltip on overflow.
   */
  children: oneOfType([string, node]).isRequired,
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
export default SovosToolbarTitle;